import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-triangle-bottom"} maskId="square-filled-radius-0-stroke-1-IconArrowTriangleBottom"><path d="M3.69092 4L11.9999 20.618L20.309 4H3.69092Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowTriangleBottom;
